import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import {
  Group,
  AddMembers,
  RemoveMembers,
  AddMemberRequest,
} from '../../admin/group-setup/group.model';
import { throwError } from 'rxjs';
import { LogService } from 'src/app/shared/services/log.service';
import { GroupMembers } from 'src/app/shared/models/group-members.model';
import { Member } from 'src/app/shared/profile/profile/member.model';
import { ViewMembers } from 'src/app/core/groups/view-members/view-members.model';
import { memberGroups } from '../models/member-groups.model';

@Injectable({ providedIn: 'root' })
export class GroupService {
  apiHost: string = environment.apiHost;
  GroupArr: Group[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  async loadGroupsQuick(): Promise<Group[]> {
    var data = await this.getAllGroupsQuick();
    if (data == null) data = [];
    this.GroupArr = data.map((a) => {
      let s: Group = new Group();
      s.id = a.id;
      s.name = a.name;
      s.description = a.description;
      s.mission = a.mission;
      s.accessibility = a.accessibility;
      s.accessibilityName = a.accessibilityName;
      s.requestWorkflow = a.requestWorkflow;
      s.requestQuestion = a.requestQuestion;
      s.invitationWorkflow = a.invitationWorkflow;
      s.pictureUrl = a.pictureUrl;
      s.autoAssign = a.autoAssign;
      s.autoRemove = a.autoRemove;
      s.capacity = a.capacity;
      s.promotionGroupId = a.promotionGroupId;
      s.promotionGroupName = a.promotionGroupName;
      s.flagged = a.flagged;
      return s;
    });
    return this.GroupArr;
  }

  async loadGroups(): Promise<Group[]> {
    var data = await this.getAllGroups();
    if (data == null) data = [];
    this.GroupArr = data.map((a) => {
      let s: Group = new Group();
      s.id = a.id;
      s.name = a.name;
      s.description = a.description;
      s.mission = a.mission;
      s.accessibility = a.accessibility;
      s.accessibilityName = a.accessibilityName;
      s.requestWorkflow = a.requestWorkflow;
      s.requestQuestion = a.requestQuestion;
      s.invitationWorkflow = a.invitationWorkflow;
      s.pictureUrl = a.pictureUrl;
      s.autoAssign = a.autoAssign;
      s.autoRemove = a.autoRemove;
      s.capacity = a.capacity;
      s.promotionGroupId = a.promotionGroupId;
      s.promotionGroupName = a.promotionGroupName;
      s.flagged = a.flagged;
      return s;
    });
    this.GroupArr = this.GroupArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
    return this.GroupArr;
  }

  async loadActiveGroups(): Promise<Group[]> {
    var data = await this.getActiveGroups();
    if (data == null) data = [];
    this.GroupArr = data.map((a) => {
      let s: Group = new Group();
      s.id = a.id;
      s.name = a.name;
      s.description = a.description;
      s.mission = a.mission;
      s.accessibility = a.accessibility;
      s.accessibilityName = a.accessibilityName;
      s.requestWorkflow = a.requestWorkflow;
      s.requestQuestion = a.requestQuestion;
      s.invitationWorkflow = a.invitationWorkflow;
      s.pictureUrl = a.pictureUrl;
      s.autoAssign = a.autoAssign;
      s.autoRemove = a.autoRemove;
      s.capacity = a.capacity;
      s.promotionGroupId = a.promotionGroupId;
      s.promotionGroupName = a.promotionGroupName;
      s.flagged = a.flagged;
      return s;
    });
    this.GroupArr = this.GroupArr.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });    
    return this.GroupArr;
  }  

  getActiveGroups(): Promise<Group[]> {
    let promise = new Promise<Group[]>((resolve, reject) => {
      return this.http
        .get<Group[]>(this.apiHost + '/Group/GetActive')
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Active Groups', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllGroupsQuick(): Promise<any[]> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .get<any[]>(this.apiHost + '/Group/getallquick')
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllGroups(): Promise<any[]> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .get<any[]>(this.apiHost + '/Group/getall')
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getGroup(GroupId: number): Promise<Group> {
    let promise = new Promise<Group>((resolve, reject) => {
      return this.http
        .get<Group>(this.apiHost + '/Group/get?GroupId=' + GroupId.toString())
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Active', msg);
            reject(msg);
          }
        );
    });  
    return promise;
  }

  getMembersByGroup(groupId: number): Promise<ViewMembers[]> {
    let promise = new Promise<ViewMembers[]>((resolve, reject) => {
      return this.http
        .get<ViewMembers[]>(
          this.apiHost + '/Member/GetMembersByGroupId?GroupId=' + groupId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Members by GroupId', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  deleteGroup(GroupId: number): Promise<Group> {
    let promise = new Promise<Group>((resolve, reject) => {
      return this.http
        .post<Group>(
          this.apiHost + '/Group/delete?GroupId=' + GroupId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Delete Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addGroup(Group: Group): Promise<Group> {
    let promise = new Promise<Group>((resolve, reject) => {
      return this.http
        .post<Group>(this.apiHost + '/Group/Add', Group)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  updateGroup(Group: Group): Promise<Group> {
    let promise = new Promise<Group>((resolve, reject) => {
      return this.http
        .post<Group>(this.apiHost + '/Group/Update', Group)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  updateFilter(groupId: number, filter: string): Promise<Group> {
    let promise = new Promise<Group>((resolve, reject) => {
      return this.http
        .post<Group>(this.apiHost + '/Group/UpdateFilter', {
          Id: groupId,
          Filter: filter,
        })
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update Filter', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteGroup(GroupId: number): Promise<Group> {
    let promise = new Promise<Group>((resolve, reject) => {
      return this.http
        .post<Group>(
          this.apiHost +
            '/Group/delete?GroupId=' +
            GroupId.toString() +
            '&showHide=true',
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          }, 
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Undelete Group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getMembersOfGroup(groupId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .get<any>(
          this.apiHost + '/Group/GetMembers?GroupId=' + groupId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Members of group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addMembersToGroup(addMembers: AddMembers): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Group/AddMembers', addMembers)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Members to group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addMemberRequestToGroup(addMember: AddMemberRequest): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Group/AddMemberRequest', addMember)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Add Member Request to group',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  inviteToGroup(addMembers: AddMembers): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Group/InviteMembers', addMembers)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Invite Members to group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  removeMembersFromGroup(removeMembers: RemoveMembers): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Group/RemoveMembers', removeMembers)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Remove Members from group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  checkLeadershipEligibility(memberIds: number[]): Promise<{eligible: boolean; messageKey?: string}> {
    return this.http.post<{eligible: boolean; messageKey?: string}>(this.apiHost + '/Permission/LeadershipEligibility', memberIds).toPromise();
  }

  addLeadershipToGroup(addMembers: AddMembers): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Group/AddLeaders', addMembers)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Leaders to group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  removeLeadershipFromGroup(removeMembers: RemoveMembers): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(this.apiHost + '/Group/RemoveLeaders', removeMembers)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Remove Leaders to group', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  promotionSafe(groupId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .get<any>(
          this.apiHost + '/Group/PromotionSafe?groupId=' + groupId.toString()
        )
        .toPromise()
        .then((data) => {
          if (data.statusCode == 200) resolve(data);
          else reject(data);
        });
    });
    return promise;
  }

  demotionSafe(groupId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .get<any>(
          this.apiHost + '/Group/DemotionSafe?groupId=' + groupId.toString()
        )
        .toPromise()
        .then((data) => {
          if (data.statusCode == 200) resolve(data);
          else reject(data);
        });
    });
    return promise;
  }

  promoteGroup(groupId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Group/PromoteGroup?GroupId=' + groupId.toString(),
          null
        )
        .toPromise()
        .then((data) => {
          if (data.statusCode == 200) resolve(data);
          else reject(data);
        });
    });
    return promise;
  }

  demoteGroup(groupId: number): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Group/DemoteGroup?GroupId=' + groupId.toString(),
          null
        )
        .toPromise()
        .then((data) => {
          if (data.statusCode == 200) resolve(data);
          else reject(data);
        });
    });
    return promise;
  }

  promoteMembers(groupId: number, memberList: number[]): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Group/PromoteMembers?GroupId=' + groupId.toString(),
          memberList
        )
        .toPromise()
        .then(
          (data) => {
            if (data.statusCode == 200) resolve(data);
            else reject(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Promote Members', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  demoteMembers(groupId: number, memberList: number[]): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Group/DemoteMembers?GroupId=' + groupId.toString(),
          memberList
        )
        .toPromise()
        .then(
          (data) => {
            if (data.statusCode == 200) resolve(data);
            else reject(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Demote Members', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getPromotionNames(groupId: number): Promise<string> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .get<any>(
          this.apiHost +
            '/Group/GetPromotionNames?GroupId=' +
            groupId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Promotion Names', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getDropDowns(): Promise<any[]> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .get<any[]>(this.apiHost + '/Group/getdropdowns')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: Get All grouping structure',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  getGroupMembersByUserId(userId: string): Promise<GroupMembers[]> {
    let promise = new Promise<GroupMembers[]>((resolve, reject) => {
      return this.http
        .get<GroupMembers[]>(
          this.apiHost + '/group/GetGroupMembersByUserId?UserId=' + userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: getGroup Members ByUserId', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getPublicGroupsByUserId(userId: string): Promise<GroupMembers[]> {
    let promise = new Promise<GroupMembers[]>((resolve, reject) => {
      return this.http
        .get<GroupMembers[]>(
          this.apiHost + '/group/GetPublicGroupsByUserId?UserId=' + userId
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog(
                'Admin: getPublic Group Members ByUserId',
                msg
              );
            reject(msg);
          }
        );
    });
    return promise;
  }

  getGroupsByMemberId(MemberId: number): Promise<memberGroups> {
    let promise = new Promise<memberGroups>((resolve, reject) => {
      return this.http
        .get<memberGroups>(this.apiHost + '/Group/GetGroupsByMemberId?MemberId=' + MemberId.toString())
        .toPromise()
        .then(
          (data) => {
            resolve(data['dataResult']);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Member Groups', msg);
            reject(msg);
          }
        );
    });  
    return promise;
  }

  refreshCurrentGroups(): Promise<any> {
    let promise = new Promise<any>((resolve, reject) => {
      return this.http
        .post<any>(
          this.apiHost + '/Group/Refresh',
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Refresh Current Groups', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
